import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';

const EditButton = ({ rowData }) => {
  const history = useNavigate();
  const handleClick = () => {
    history(`edit-invoice/${rowData.invoiceUniqueIdentifier}`);
  };

  return <Button link onClick={handleClick} icon={'pi pi-file-edit'} />;
};

export default React.memo(EditButton);
